/* @flow */

import { call, put, take } from 'redux-saga/effects'

import type { Action } from '../types'

import { sagaGet } from '../fetch'
import { API_ICONS_URL } from '../urls'
import {
  BadResponseError,
  SagaMalfunctionError,
  sagaHandleError,
} from '../helpers'
import {
  getCustomersFromLegacyEntities,
  getIconsFromLegacyIcons,
} from '../legacy'

import { setIsFetchingIcons } from '../stores/pending'

import { sagaLogoutUnauthorizedUser } from './logout'

import { intoCustomersStore } from '../stores/customersStore'
import { intoIconsStore } from '../stores/iconsStore'

export const FETCH_ICONS_INTO_STORE: string = 'opinary/FETCH_ICONS_INTO_STORE'

export function fetchIconsIntoStore(): Action {
  return {
    type: FETCH_ICONS_INTO_STORE,
  }
}

export function* sagaFetchIconsIntoStore(): Generator<*, void, *> {
  const response = yield call(sagaGet, API_ICONS_URL)

  if (response == null) throw new SagaMalfunctionError()
  if (response.status === 401 || response.status === 403)
    yield call(sagaLogoutUnauthorizedUser)
  if (response.status !== 200) throw new BadResponseError(response)

  const legacyIcons = yield call([response, response.json])

  if (legacyIcons == null) throw new SagaMalfunctionError()

  yield put(intoCustomersStore(getCustomersFromLegacyEntities(legacyIcons)))
  yield put(intoIconsStore(getIconsFromLegacyIcons(legacyIcons)))
}

export function* sagaRepeatedlyFetchIconsIntoStore(): Generator<*, void, *> {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    yield take(FETCH_ICONS_INTO_STORE)

    yield put(setIsFetchingIcons(true))
    try {
      yield sagaFetchIconsIntoStore()
    } catch (err) {
      yield call(sagaHandleError, err)
    }
    yield put(setIsFetchingIcons(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/fetchIcons.js